import { tv, type VariantProps } from 'tailwind-variants';
export type AtTagVariants = VariantProps<typeof atTagVariants>;

const atTagVariants = tv({
  base: 'rounded-full px-4 py-3 box-border flex flex-row justify-center items-center gap-1.5 font-medium',
  variants: {
    variant: {
      featured: 'bg-chiclet-featured text-chiclet-default',
      default: 'bg-chiclet-default text-chiclet-default',
      offers: 'bg-chiclet-offers text-chiclet-offers',
      location:
        'bg-chiclet-location text-chiclet-location hover:bg-chiclet-location-hover hover:text-chiclet-location-hover',
    },
    size: {
      sm: '',
      lg: '',
    },
  },
  compoundVariants: [
    {
      variant: ['default', 'featured'],
      size: ['sm', 'lg'],
      className: 'paragraph-xs',
    },
    {
      variant: 'offers',
      size: ['sm', 'lg'],
      className: 'paragraph-sm lg:paragraph-md',
    },
    {
      variant: 'location',
      size: 'sm',
      className: 'paragraph-sm lg:paragraph-xs',
    },
    {
      variant: 'location',
      size: 'lg',
      className: 'paragraph-sm',
    },
  ],
});

export default atTagVariants;
